import WForeverMobile from './WForeverMobile'

export default WForeverMobile
